import { render, staticRenderFns } from "./ImportChanges.vue?vue&type=template&id=01ef1d14&scoped=true&"
import script from "./ImportChanges.vue?vue&type=script&lang=js&"
export * from "./ImportChanges.vue?vue&type=script&lang=js&"
import style0 from "./ImportChanges.vue?vue&type=style&index=0&id=01ef1d14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ef1d14",
  null
  
)

export default component.exports